module.exports = __webpack_public_path__ + "img/sz001-002.e59c7b13.jpg";